import { useState, useRef, useEffect, Fragment } from "react";
import Config from "../../Config";



import edit from "../../edit.png";
import trash from "../../trash.png";
import restore from "../../restore.png";
import korekt from "../../korekt.png";
import contract from "../../contract.png";
import search from "../../search.png";
import gopresent from "../../gopresent.png";


import PlTitle from "../../elements/PlTitle";
import InputComboGrupa from "../../helpers/InputComboGrupa";
import InputTextAlpha from "../../helpers/InputTextAlpha";
import InputPagger from "../../helpers/InputPagger";
import InputLegend from "../../helpers/InputLegend";
import InputText from "../../helpers/InputText";
import InputDate from "../../helpers/InputDate";
import InputCombo from "../../helpers/InputCombo";
import InputComboSubkonto from "../../helpers/InputComboSubkonto";
import InputDecimal from "../../helpers/InputDecimal";


import Csv from "../../exporter/Csv";
import Print from "../../exporter/Print";
import HtmlToPDF from "../../exporter/HtmlToPDF";
import FormatDecimal from "../../helpers/FormatDecimal";

import InvoiceGenerate from "./InvoiceGenerate";
import InvoiceNew from "./InvoiceNew";
import InvoiceEdit from "./InvoiceEdit";
import InvoiceKor from "./InvoiceKor";
import InvoiceEditMass from "./InvoiceEditMass";

import CalculateEdit from "./CalculateEdit";
import QuickChat from "../msg/QuickChat";
import SortBy from "../../helpers/SortBy";
import MenuTable from "../../helpers/MenuTable";
import InvoiceApprove from "./InvoiceApprove";
import InvoiceKorMass from "./InvoiceKorMass";
import AppContext from "../../AppContext";
import PackToZip from "../home/PackToZip";
import InputComboStawkiWyzMulti from "../../helpers/InputComboStawkiWyzMulti";
import Xlsx from "../../exporter/Xlsx";



function Invoice(props)
{

 
    


    const [refreshView, setRefreshView] = useState(props.userData.refreshView);


    const [allFilter, setAllFilter] = useState(0);

    const [filterParam, setFilterParam] = useState({
        numer: props.mainView.readFilter('numer',''),
        d_imie_nazwisko: props.mainView.readFilter('d_imie_nazwisko',''), 
        r_imie_nazwisko: props.mainView.readFilter('r_imie_nazwisko',''), 
  
        p_grupa_id: props.mainView.readFilter('p_grupa_id','_x_'), 

        data_wystawienia_od: props.mainView.readFilter('data_wystawienia_od',''), 
        data_wystawienia_do: props.mainView.readFilter('data_wystawienia_do',''), 

        stan_dokumentu: props.mainView.readFilter('stan_dokumentu','_x_'), 
        rozliczone: props.mainView.readFilter('rozliczone','_x_'), 
        korekta: props.mainView.readFilter('korekta','_x_'), 

        usuniety: props.mainView.readFilter('usuniety','0'), 

        p_subkonta_id: props.mainView.readFilter('p_subkonta_id','_x_'),  

        do_zaplaty_od: props.mainView.readFilter('do_zaplaty_od',''),  
        do_zaplaty_do: props.mainView.readFilter('do_zaplaty_do',''),  

        kwota_rozliczenia_od: props.mainView.readFilter('kwota_rozliczenia_od',''),  
        kwota_rozliczenia_do: props.mainView.readFilter('kwota_rozliczenia_do',''),  

        pozostalo_od: props.mainView.readFilter('pozostalo_od',''),  
        pozostalo_do: props.mainView.readFilter('pozostalo_do',''),  

        wyslano_sms: props.mainView.readFilter('wyslano_sms','_x_'),  
        wyslano_e_fakture: props.mainView.readFilter('wyslano_e_fakture','_x_'),  

        typ_dok: props.mainView.readFilter('typ_dok','_x_'),  

        wg_umowy: props.mainView.readFilter('wg_umowy','_x_'),  

        zawiera_stawke: '',
        niezawiera_stawki: '',    
     

        sortBy: {
            sort:  "", //asc desc,
            column: "",
        },

        limit: 50,
        page: 1,
        pages: 1,
        show: true,
    });
    const [tab, setTab] = useState(null);
    const [tabSum, setTabSum] = useState([]);
    const [selectedRow, setSelectedRow] = useState([]);


    const [gr, setGr] = useState([]);
    const fetchGr = (fTab) => {   setGr(fTab);  }


    const tabRef = useRef(0); //do druku
    const tab2Ref = useRef(0);

    const sumRef = useRef(0);
    const sumRefPdf = useRef(0);


    const [view, setView] = useState ( {
        v:'list',
        id: -1
    } );



    const [legend, setLegend] = useState([
         {
            cls:'color_wrong',
            title: 'po terminie',
            filter: {  filed: "po_terminie", set: "1", typ: "combo"  },
        },
        {
            cls:'color_deleted2',
            title: 'dokument usunięty',
            filter: {  filed: "usuniety", set: "1", typ: "combo"  },
        },
        {
            cls:'color_deleted',
            title: 'dokument anulowany',
            filter: {  filed: "stan_dokumentu", set: "12",  typ: "combo"  },
        },
        {
            cls:'color_show3',
            title: 'dokument niewystawiony',
            filter: {  filed: "stan_dokumentu", set: "11", typ: "combo"  },
        },
        {
            cls:'color_show2',
            title: 'rozliczony w całości',
            filter: {  filed: "rozliczone", set: "a", typ: "combo"  },
        },
    ]);
       
    const changeView = (e ) => {
        var v = e.target.getAttribute('v');
        var id = e.target.getAttribute('id');



        if(v == 'roz' && id < 0)
        {
            props.mainView.showDialog(props.userData.dic.dlg_notice_wrong , 'Nie można przejść do rozliczeń. Czy na pewno dokument został zatwierdzony?' ,  "ok"  ,null); 
            return;
        }


        setView({...view, ["v"]:v, ["id"]:id });
}

    const onBack = (e) => {

        setView({...view, ["v"]:"list", ["id"]:"-1" }); 
        getTab();
        
    }





    const getTab = () => {
            
        
        props.mainView.setProgress(-2);

    

        fetch( Config.url + '/rest_v1_calc,invoices', {
            method: 'POST', 
            body: JSON.stringify(filterParam), 
            headers: {
                'Content-Type': 'application/json',                    
                'X-Api-Key': props.userData.apiKey,
                '_p_przedszkole_id_': props.userData.p_przedszkole_id,
                '_p_dziecko_id_': props.userData.p_dziecko_id,
                '_sec_key_': Config.genXKey() ,
            }
        })
        .then(res => res.json() )
        .then(res => { 

                    props.mainView.setProgress(-1);        
                    if(res._sys_ == undefined)
                    {
                        props.mainView.showDialog( "Error", "No correct response from server" , "ok" , null);  
                    }else
                    if(res.status != undefined && res.status == 'ERROR'  && res.result != undefined )
                    {
                        props.mainView.showDialog( "Error", JSON.stringify(res.result) , "ok" , null);  
                    }else    
                    {
                        setTab(res.result);  
                        setTabSum(res.result_sum);  

                        var newSelector = [];

                        res.result.forEach( (item) => {
                            newSelector.push({
                                id: item.id,
                                title: item.numer + " ("+item.dziecko.imie + " " + item.dziecko.nazwisko +")",
                                stan_dokumentu: item.stan_dokumentu	,
                                data_wystawienia: item.data_wystawienia,
                                selected: 0,
                                plg_pliki_id: item.plg_pliki_id,
                            });
                            
                        } )

                        setSelectedRow(newSelector);

                        if(res.pages != undefined )setFilterParam( {...filterParam,   ['pages']: res.pages  } );             
                    }
        } )
        .catch(err => {          
                    props.mainView.showDialog( "Error", "I: " + err , "ok" , null);
                    props.mainView.setProgress(-1);
        });
                

        return false;
    }




    const valChangeListener = (filedName, val, correct, msg) => {

        // console.log("valChangeListener: " + filedName + " " + val + ", correct: " + correct + ", msg: " + msg);

        setFilterParam( {...filterParam, [filedName]:val,  [filedName+"_valid"]:correct } );
        
        if(   (val.length == 0 || val.length > 2 || msg =='combo')  && filterParam[filedName] != val )
            {
                    var defTimeOut = 1000;
                    if(msg == 'combo') defTimeOut = 10;
                    clearTimeout(AppContext.timeoutId);
                    AppContext.timeoutId = setTimeout( () => {
                        setTab(null); 
                    } , defTimeOut );
            }

        props.mainView.writeFilter(filedName, val);
    }

    

    const goNextNew = () => {
        console.log("goNext");    
        setTab(null);    
    }

    const moreFilter = () => {
        if(allFilter == 0) { setAllFilter(1); } else setAllFilter(0);
    }

    const filterView = () => {
        setFilterParam(  {...filterParam, ["show"]:!filterParam.show } );
    }

    const filterClear = () => {

        props.mainView.writeFilter('numer', '');
        props.mainView.writeFilter('d_imie_nazwisko', '');    
        props.mainView.writeFilter('r_imie_nazwisko', '');    
        props.mainView.writeFilter('p_group_id', '_x_');

        props.mainView.writeFilter('data_wystawienia_od', '');
        props.mainView.writeFilter('data_wystawienia_do', '');

        props.mainView.writeFilter('stan_dokumentu', '_x_');
        props.mainView.writeFilter('rozliczone', '_x_');
        props.mainView.writeFilter('korekta', '_x_');
        props.mainView.writeFilter('usuniety', '0');
        props.mainView.writeFilter('p_subkonta_id', '_x_');
        props.mainView.writeFilter('do_zaplaty_od', '');
        props.mainView.writeFilter('do_zaplaty_do', '');
        props.mainView.writeFilter('kwota_rozliczenia_od', '');
        props.mainView.writeFilter('kwota_rozliczenia_do', '');
        props.mainView.writeFilter('pozostalo_od', '');
        props.mainView.writeFilter('pozostalo_do', '');

        props.mainView.writeFilter('wyslano_sms', '_x_');
        props.mainView.writeFilter('wyslano_e_fakture', '_x_');

        props.mainView.writeFilter('typ_dok', '_x_');
        props.mainView.writeFilter('wg_umowy', '_x_');
   

        setFilterParam({
            numer: '',
            d_imie_nazwisko: '',                                    
            r_imie_nazwisko: '',                                    
            p_grupa_id: '_x_',        
            
            data_wystawienia_od: '',
            data_wystawienia_do: '',

            stan_dokumentu: '_x_',
            rozliczone: '_x_',
            korekta: '_x_',
            usuniety: '0',
            p_subkonta_id: '_x_',

            do_zaplaty_od: '',
            do_zaplaty_do: '',

            kwota_rozliczenia_od: '',
            kwota_rozliczenia_do: '',

            pozostalo_od: '',
            pozostalo_do: '',

            wyslano_sms: '_x_',
            wyslano_e_fakture: '_x_',

            zawiera_stawke: '',
            niezawiera_stawki: '',    

            typ_dok: '_x_',
            wg_umowy: '_x_',

            sortBy: {
                sort:  "", //asc desc,
                column: "",
            },

            limit: 50,
            page: 1,
            show: true,
        });
        setTab(null);
    }

    const filterApprove = () => {   
        setTab(null)     
    }

    const onChangePagger = (x_limit, x_page) => {

        setFilterParam(  {...filterParam, ["limit"]:x_limit, ["page"]:x_page} );
        setTab(null);
    }

    const onChangeSortBy = (sortBy) => {

        setFilterParam(  {...filterParam, ["sortBy"]:sortBy } );
        setTab(null);
    }






    //-------------------------------------------------------
//-------------------------------------------------------
//MASS
const changeSelected = (e) => {

    var id    = e.target.getAttribute('atr-id');   
    var selected = 0;

    if(e.target.checked) selected = 1;

    for(var k=0; k<selectedRow.length; k++)
    {
        if(selectedRow[k].id == id)  selectedRow[k].selected = selected;
    }

    setSelectedRow(  JSON.parse(JSON.stringify(selectedRow) ) );    
}

const changeSelectedAll = (e) => {

    var s = selectedRow[0].selected;
    if(s == 1) {  s = 0; } else s = 1;

    for(var k=0; k<selectedRow.length; k++)
        {
          selectedRow[k].selected = s;
        }
    
        setSelectedRow(  JSON.parse(JSON.stringify(selectedRow) ) ); 

}


//-------------------------------------------------------
//-------------------------------------------------------

const goApprove = (e) =>
    {
 
    
        var ids = new Array();
    
        for(var k=0; k<selectedRow.length; k++)
            {
               if( selectedRow[k].selected == 1)
               {
                    ids.push({
                        id: selectedRow[k].id,
                        title: selectedRow[k].title
                    });
               }
            }
        
    
         if(ids.length < 1)     
         {       
            props.mainView.showDialog(props.userData.dic.dlg_notice_wrong , 'Nie wybrano żadnego dokumentu' ,  "ok"  ,null); 
            return;              
         }
    
    
        props.mainView.showDialog("Potwierdź", "Na pewno chcesz wystawić wybrane dokumenty?", "yesno", (option)=>{
              
            ///--------
            if(option == "yes")
            {
                        props.mainView.setProgress(-2);
    
                        var req = {
                            ids: ids,                        
                        }
    
                        fetch( Config.master + '/rest_v1_calc,approve', {
                            method: 'POST', 
                            body: JSON.stringify(req), 
                            headers: {
                                'Content-Type': 'application/json',                    
                                'X-Api-Key': props.userData.apiKey,
                                '_p_przedszkole_id_': props.userData.p_przedszkole_id,
                                '_p_dziecko_id_': props.userData.p_dziecko_id,
                                '_sec_key_': Config.genXKey() ,
                            }
                        })
                        .then(res => res.json() )
                        .then(res => { 
    
                                    props.mainView.setProgress(-1);        
                                    if(res._sys_ == undefined)
                                    {
                                        props.mainView.showDialog( "Error", "No correct response from server" , "ok" , null);  
                                    }else
                                    if(res.status != undefined && res.status == 'ERROR'  && res.result != undefined )
                                    {
                                        props.mainView.showDialog( "Error", JSON.stringify(res.result) , "ok" , null);  
                                    }else    
                                    {      
                                        props.mainView.showDialog( "Sukces", "Wystawiono dokumentów: " + res.result , "ok" , null);                               
                                        getTab();            
                                    }
                        } )
                        .catch(err => {          
                                    props.mainView.showDialog( "Error", "I: " + err , "ok" , null);
                                    props.mainView.setProgress(-1);
                        });
            }//koniec yes
            //--------
        } );
    
    }
    


const cancelInvoice = (e) => {


    var id = e.target.getAttribute('atr-id');
    var title = e.target.getAttribute('atr-title');
    var ids = new Array();


    ids.push({
        id: id,
        title: title,
    });




    props.mainView.showDialog("Potwierdź", "Czy na pewno chcesz anulować  dokument \"" + title + "\" ?", "yesno", (option)=>{
                  
        ///--------
        if(option == "yes")
        {
                    props.mainView.setProgress(-2);

                    var req = {
                        ids: ids,                            
                    }

                    fetch( Config.url + '/rest_v1_calc,cancel', {
                        method: 'POST', 
                        body: JSON.stringify(req), 
                        headers: {
                            'Content-Type': 'application/json',                    
                            'X-Api-Key': props.userData.apiKey,
                            '_p_przedszkole_id_': props.userData.p_przedszkole_id,
                            '_p_dziecko_id_': props.userData.p_dziecko_id,
                            '_sec_key_': Config.genXKey() ,
                        }
                    })
                    .then(res => res.json() )
                    .then(res => { 

                                props.mainView.setProgress(-1);        
                                if(res._sys_ == undefined)
                                {
                                    props.mainView.showDialog( "Error", "No correct response from server" , "ok" , null);  
                                }else
                                if(res.status != undefined && res.status == 'ERROR'  && res.result != undefined )
                                {
                                    props.mainView.showDialog( "Error", JSON.stringify(res.result) , "ok" , null);  
                                }else    
                                {      
                                    props.mainView.showDialog( "Sukces", "Dokumentów anulowanych lub usuniętych: " + res.result , "ok" , null);                               
                                    getTab();            
                                }
                    } )
                    .catch(err => {          
                                props.mainView.showDialog( "Error", "I: " + err , "ok" , null);
                                props.mainView.setProgress(-1);
                    });
        }//koniec yes
        //--------
    } );

}


  const goCancel = (e) =>
            {         
                var ids = new Array();
                var wybranych = 0;
            
                for(var k=0; k<selectedRow.length; k++)
                    {
                       if( selectedRow[k].selected == 1)
                       {
                            wybranych++;
                            //sprawdz czy ten dokument można anulować...
                            var canCancel = false;

                            for(var uu=0; uu < tab.length; uu++)
                            {                               
                                if( parseInt(tab[uu].id) == parseInt( selectedRow[k].id) &&  parseFloat(tab[uu].kwota_rozliczenia) == 0 ) canCancel = true;                                                                                                                               
                            }
                    

                            if(canCancel)
                            {
                                    ids.push({
                                        id: selectedRow[k].id,
                                        title: selectedRow[k].title
                                    });
                            }

                            
                       }
                    }
                
            
                 if(ids.length < 1 && wybranych > 0)     
                 {       
                    props.mainView.showDialog(props.userData.dic.dlg_notice_wrong , 'Wybierz dokumenty, które nie są jeszcze rozliczone. ' ,  "ok"  ,null); 
                    return;              
                 }

                 if(ids.length < 1)     
                 {       
                    props.mainView.showDialog(props.userData.dic.dlg_notice_wrong , 'Nie wybrano żadnego dokumentu.' ,  "ok"  ,null); 
                    return;              
                 }
            
            
                props.mainView.showDialog("Potwierdź", "Na pewno chcesz anulować wybrane dokumenty? Możliwych do usunięcia / anulowania: " + ids.length, "yesno", (option)=>{
                      
                    ///--------
                    if(option == "yes")
                    {
                                props.mainView.setProgress(-2);
            
                                var req = {
                                    ids: ids,                            
                                }
            
                                fetch( Config.url + '/rest_v1_calc,cancel', {
                                    method: 'POST', 
                                    body: JSON.stringify(req), 
                                    headers: {
                                        'Content-Type': 'application/json',                    
                                        'X-Api-Key': props.userData.apiKey,
                                        '_p_przedszkole_id_': props.userData.p_przedszkole_id,
                                        '_p_dziecko_id_': props.userData.p_dziecko_id,
                                        '_sec_key_': Config.genXKey() ,
                                    }
                                })
                                .then(res => res.json() )
                                .then(res => { 
            
                                            props.mainView.setProgress(-1);        
                                            if(res._sys_ == undefined)
                                            {
                                                props.mainView.showDialog( "Error", "No correct response from server" , "ok" , null);  
                                            }else
                                            if(res.status != undefined && res.status == 'ERROR'  && res.result != undefined )
                                            {
                                                props.mainView.showDialog( "Error", JSON.stringify(res.result) , "ok" , null);  
                                            }else    
                                            {      
                                                props.mainView.showDialog( "Sukces", "Dokumentów anulowanych lub usuniętych: " + res.result , "ok" , null);                               
                                                getTab();            
                                            }
                                } )
                                .catch(err => {          
                                            props.mainView.showDialog( "Error", "I: " + err , "ok" , null);
                                            props.mainView.setProgress(-1);
                                });
                    }//koniec yes
                    //--------
                } );
            
            }  






  const goRestore = (e) =>
                {         
                    var ids = new Array();
                
                    for(var k=0; k<selectedRow.length; k++)
                        {
                           if( selectedRow[k].selected == 1)
                           {
                                ids.push({
                                    id: selectedRow[k].id,
                                    title: selectedRow[k].title
                                });
                           }
                        }
                    
                
                     if(ids.length < 1)     
                     {       
                        props.mainView.showDialog(props.userData.dic.dlg_notice_wrong , 'Nie wybrano żadnego dokumentu' ,  "ok"  ,null); 
                        return;              
                     }
                
                
                    props.mainView.showDialog("Potwierdź", "Na pewno chcesz przywrócić wybrane dokumenty?", "yesno", (option)=>{
                          
                        ///--------
                        if(option == "yes")
                        {
                                    props.mainView.setProgress(-2);
                
                                    var req = {
                                        ids: ids,                            
                                    }
                
                                    fetch( Config.url + '/rest_v1_calc,restore', {
                                        method: 'POST', 
                                        body: JSON.stringify(req), 
                                        headers: {
                                            'Content-Type': 'application/json',                    
                                            'X-Api-Key': props.userData.apiKey,
                                            '_p_przedszkole_id_': props.userData.p_przedszkole_id,
                                            '_p_dziecko_id_': props.userData.p_dziecko_id,
                                            '_sec_key_': Config.genXKey() ,
                                        }
                                    })
                                    .then(res => res.json() )
                                    .then(res => { 
                
                                                props.mainView.setProgress(-1);        
                                                if(res._sys_ == undefined)
                                                {
                                                    props.mainView.showDialog( "Error", "No correct response from server" , "ok" , null);  
                                                }else
                                                if(res.status != undefined && res.status == 'ERROR'  && res.result != undefined )
                                                {
                                                    props.mainView.showDialog( "Error", JSON.stringify(res.result) , "ok" , null);  
                                                }else    
                                                {      
                                                    props.mainView.showDialog( "Sukces", "Przywróconych dokumentów: " + res.result , "ok" , null);                               
                                                    getTab();            
                                                }
                                    } )
                                    .catch(err => {          
                                                props.mainView.showDialog( "Error", "I: " + err , "ok" , null);
                                                props.mainView.setProgress(-1);
                                    });
                        }//koniec yes
                        //--------
                    } );
                
                }    
        
        
      
   const goPrint = (e) =>
                    {         
                        var ids = new Array();
                    
                        for(var k=0; k<selectedRow.length; k++)
                            {
                               if( selectedRow[k].selected == 1)
                               {
                                    ids.push({
                                        id: selectedRow[k].id,
                                        title: selectedRow[k].title
                                    });
                               }
                            }
                        
                    
                         if(ids.length < 1)     
                         {       
                            props.mainView.showDialog(props.userData.dic.dlg_notice_wrong , 'Nie wybrano żadnego dokumentu' ,  "ok"  ,null); 
                            return;              
                         }
                    
                     
                         props.mainView.setProgress(-2);
                    
                         var req = {
                             ids: ids,                            
                         }
     
                         fetch( Config.url + '/rest_v1_calc,print_selected', {
                             method: 'POST', 
                             body: JSON.stringify(req), 
                             headers: {
                                 'Content-Type': 'application/json',                    
                                 'X-Api-Key': props.userData.apiKey,
                                 '_p_przedszkole_id_': props.userData.p_przedszkole_id,
                                 '_p_dziecko_id_': props.userData.p_dziecko_id,
                                 '_sec_key_': Config.genXKey() ,
                             }
                         })
                         .then(res => res.json() )
                         .then(res => { 
     
                                     props.mainView.setProgress(-1);        
                                     if(res._sys_ == undefined)
                                     {
                                         props.mainView.showDialog( "Error", "No correct response from server" , "ok" , null);  
                                     }else
                                     if(res.status != undefined && res.status == 'ERROR'  && res.result != undefined )
                                     {
                                         props.mainView.showDialog( "Error", JSON.stringify(res.result) , "ok" , null);  
                                     }else    
                                     {      
                                        if(res.status == 'OK')                  
                                        {
                                                var pdfB64 = res.result;

                                              //  document.location.href = "data:application/pdf;base64," + pdfB64;

                                                let linkB = Config.makeBase64PDFToBlobUrl(pdfB64);

                                                var anchor = document.createElement('a');
                                             //   anchor.href = "data:application/pdf;base64," + pdfB64;
                                                anchor.href = linkB;
                                                anchor.target="_blank";
                                                anchor.click();
 


                                        }
                                     }
                         } )    
                         .catch(err => {          
                                     props.mainView.showDialog( "Error", "I: " + err , "ok" , null);
                                     props.mainView.setProgress(-1);
                         });
                    
                    }    
            
     const goPrintOne = (e) =>
                        {         
                            var ids = new Array();
                         
                         
                             var id = e.target.getAttribute('atr-id');   
                             var title = e.target.getAttribute('atr-title');   
                        

                             ids.push({
                                id: id,
                                title: title
                            });

                         
                             props.mainView.setProgress(-2);
                        
                             var req = {
                                 ids: ids,                            
                             }
         
                             fetch( Config.url + '/rest_v1_calc,print_selected', {
                                 method: 'POST', 
                                 body: JSON.stringify(req), 
                                 headers: {
                                     'Content-Type': 'application/json',                    
                                     'X-Api-Key': props.userData.apiKey,
                                     '_p_przedszkole_id_': props.userData.p_przedszkole_id,
                                     '_p_dziecko_id_': props.userData.p_dziecko_id,
                                     '_sec_key_': Config.genXKey() ,
                                 }
                             })
                             .then(res => res.json() )
                             .then(res => { 
         
                                         props.mainView.setProgress(-1);        
                                         if(res._sys_ == undefined)
                                         {
                                             props.mainView.showDialog( "Error", "No correct response from server" , "ok" , null);  
                                         }else
                                         if(res.status != undefined && res.status == 'ERROR'  && res.result != undefined )
                                         {
                                             props.mainView.showDialog( "Error", JSON.stringify(res.result) , "ok" , null);  
                                         }else    
                                         {      
                                            if(res.status == 'OK')                  
                                            {
                                                    var pdfB64 = res.result;
    
                                                  //  document.location.href = "data:application/pdf;base64," + pdfB64;

                                                    let linkB = Config.makeBase64PDFToBlobUrl(pdfB64);
    
                                                    var anchor = document.createElement('a');
                                                    //anchor.href = "data:application/pdf;base64," + pdfB64;
                                                    anchor.href =  linkB;
                                                    anchor.target="_blank";
                                                    anchor.click();
                                            }
                                         }
                             } )    
                             .catch(err => {          
                                         props.mainView.showDialog( "Error", "I: " + err , "ok" , null);
                                         props.mainView.setProgress(-1);
                             });
                        
                        }    
                
                               

   const goSendByEmail = (e) =>
                        {         
                            var ids = new Array();
                        
                            for(var k=0; k<selectedRow.length; k++)
                                {
                                   if( selectedRow[k].selected == 1)
                                   {
                                        ids.push({
                                            id: selectedRow[k].id,
                                            title: selectedRow[k].title
                                        });
                                   }
                                }
                            
                        
                             if(ids.length < 1)     
                             {       
                                props.mainView.showDialog(props.userData.dic.dlg_notice_wrong , 'Nie wybrano żadnego dokumentu' ,  "ok"  ,null); 
                                return;              
                             }
                        
                         
                             props.mainView.setProgress(-2);
                        
                             var req = {
                                 ids: ids,                            
                             }
         
                             fetch( Config.url + '/rest_v1_calc,send_email_selected', {
                                 method: 'POST', 
                                 body: JSON.stringify(req), 
                                 headers: {
                                     'Content-Type': 'application/json',                    
                                     'X-Api-Key': props.userData.apiKey,
                                     '_p_przedszkole_id_': props.userData.p_przedszkole_id,
                                     '_p_dziecko_id_': props.userData.p_dziecko_id,
                                     '_sec_key_': Config.genXKey() ,
                                 }
                             })
                             .then(res => res.json() )
                             .then(res => { 
         
                                         props.mainView.setProgress(-1);        
                                         if(res._sys_ == undefined)
                                         {
                                             props.mainView.showDialog( "Error", "No correct response from server" , "ok" , null);  
                                         }else
                                         if(res.status != undefined && res.status == 'ERROR'  && res.result != undefined )
                                         {
                                             props.mainView.showDialog( "Error", JSON.stringify(res.result) , "ok" , null);  
                                         }else    
                                         {      
                                            if(res.status == 'OK')                  
                                            {
                                                props.mainView.showDialog( "Sukces", "Wybrane dokumenty zostały przekazane do wysyłki." , "ok" , null);    
                                            }
                                         }
                             } )    
                             .catch(err => {          
                                         props.mainView.showDialog( "Error", "I: " + err , "ok" , null);
                                         props.mainView.setProgress(-1);
                             });
                        
                        }    
                
                            
    const goSendBySMS = (e) =>
                            {         
                                var ids = new Array();
                            
                                for(var k=0; k<selectedRow.length; k++)
                                    {
                                       if( selectedRow[k].selected == 1)
                                       {
                                            ids.push({
                                                id: selectedRow[k].id,
                                                title: selectedRow[k].title
                                            });
                                       }
                                    }
                                
                            
                                 if(ids.length < 1)     
                                 {       
                                    props.mainView.showDialog(props.userData.dic.dlg_notice_wrong , 'Nie wybrano żadnego dokumentu' ,  "ok"  ,null); 
                                    return;              
                                 }
                            
                             
                                 props.mainView.setProgress(-2);
                            
                                 var req = {
                                     ids: ids,                            
                                 }
             
                                 fetch( Config.url + '/rest_v1_calc,send_sms_selected', {
                                     method: 'POST', 
                                     body: JSON.stringify(req), 
                                     headers: {
                                         'Content-Type': 'application/json',                    
                                         'X-Api-Key': props.userData.apiKey,
                                         '_p_przedszkole_id_': props.userData.p_przedszkole_id,
                                         '_p_dziecko_id_': props.userData.p_dziecko_id,
                                         '_sec_key_': Config.genXKey() ,
                                     }
                                 })
                                 .then(res => res.json() )
                                 .then(res => { 
             
                                             props.mainView.setProgress(-1);        
                                             if(res._sys_ == undefined)
                                             {
                                                 props.mainView.showDialog( "Error", "No correct response from server" , "ok" , null);  
                                             }else
                                             if(res.status != undefined && res.status == 'ERROR'  && res.result != undefined )
                                             {
                                                 props.mainView.showDialog( "Error", JSON.stringify(res.result) , "ok" , null);  
                                             }else    
                                             {      
                                                if(res.status == 'OK')                  
                                                {
                                                    props.mainView.showDialog( "Error", "Wybrane dokumenty zostały przekazane do wysyłki." , "ok" , null);    
                                                }
                                             }
                                 } )    
                                 .catch(err => {          
                                             props.mainView.showDialog( "Error", "I: " + err , "ok" , null);
                                             props.mainView.setProgress(-1);
                                 });
                            
                            }    
       




    const restoreInvoice = (e) => {

    
            var id = e.target.getAttribute('atr-id');
            var title = e.target.getAttribute('atr-title');
            var ids = new Array();
        
        
            ids.push({
                id: id,
                title: title,
            });
        
                
        
            props.mainView.showDialog("Potwierdź", "Czy na pewno chcesz przywrócić dokument \"" + title + "\" ?", "yesno", (option)=>{
                          
                ///--------
                if(option == "yes")
                {
                            props.mainView.setProgress(-2);
        
                            var req = {
                                ids: ids,                            
                            }
        
                            fetch( Config.url + '/rest_v1_calc,restore', {
                                method: 'POST', 
                                body: JSON.stringify(req), 
                                headers: {
                                    'Content-Type': 'application/json',                    
                                    'X-Api-Key': props.userData.apiKey,
                                    '_p_przedszkole_id_': props.userData.p_przedszkole_id,
                                    '_p_dziecko_id_': props.userData.p_dziecko_id,
                                    '_sec_key_': Config.genXKey() ,
                                }
                            })
                            .then(res => res.json() )
                            .then(res => { 
        
                                        props.mainView.setProgress(-1);        
                                        if(res._sys_ == undefined)
                                        {
                                            props.mainView.showDialog( "Error", "No correct response from server" , "ok" , null);  
                                        }else
                                        if(res.status != undefined && res.status == 'ERROR'  && res.result != undefined )
                                        {
                                            props.mainView.showDialog( "Error", JSON.stringify(res.result) , "ok" , null);  
                                        }else    
                                        {      
                                            props.mainView.showDialog( "Sukces", "Dokumentów przywróconych: " + res.result , "ok" , null);                               
                                            getTab();            
                                        }
                            } )
                            .catch(err => {          
                                        props.mainView.showDialog( "Error", "I: " + err , "ok" , null);
                                        props.mainView.setProgress(-1);
                            });
                }//koniec yes
                //--------
            } );
        
        }






    const goKorekta = (e) => {


            var id = e.target.getAttribute('atr-id');
            var title = e.target.getAttribute('atr-title');
            var ids = new Array();
        
        
            ids.push({
                id: id,
                title: title,
            });
        
        
        
        
            props.mainView.showDialog("Potwierdź", "Czy na pewno chcesz dokonać korekty dokumentu \"" + title + "\" ?", "yesno", (option)=>{
                          
                ///--------
                if(option == "yes")
                {
                            props.mainView.setProgress(-2);
        
                            var req = {
                                ids: ids,                            
                            }
        
                            fetch( Config.url + '/rest_v1_calc,create_correct', {
                                method: 'POST', 
                                body: JSON.stringify(req), 
                                headers: {
                                    'Content-Type': 'application/json',                    
                                    'X-Api-Key': props.userData.apiKey,
                                    '_p_przedszkole_id_': props.userData.p_przedszkole_id,
                                    '_p_dziecko_id_': props.userData.p_dziecko_id,
                                    '_sec_key_': Config.genXKey() ,
                                }
                            })
                            .then(res => res.json() )
                            .then(res => { 
        
                                        props.mainView.setProgress(-1);        
                                        if(res._sys_ == undefined)
                                        {
                                            props.mainView.showDialog( "Error", "No correct response from server" , "ok" , null);  
                                        }else
                                        if(res.status != undefined && res.status == 'ERROR'  && res.result != undefined )
                                        {
                                            props.mainView.showDialog( "Error", JSON.stringify(res.result) , "ok" , null);  
                                        }else    
                                        {      
                                            if(res.result > 0 )                               
                                            {
                                              //  getTab();   
                                                setView({
                                                    v: "korekta",
                                                    id: res.result
                                                });

                                            }else 
                                            {
                                                props.mainView.showDialog( "Ups!", "Nie można utworzyć korekty dla wybranego dokumentu." , "ok" , null);  
                                            }
                                                   
                                        }
                            } )
                            .catch(err => {          
                                        props.mainView.showDialog( "Error", "I: " + err , "ok" , null);
                                        props.mainView.setProgress(-1);
                            });
                }//koniec yes
                //--------
            } );
        
        }
        


        
    const goZwrot = (e) => {


        var id = e.target.getAttribute('atr-id');
        var title = e.target.getAttribute('atr-title');
        var ids = new Array();
    
    
        ids.push({
            id: id,
            title: title,
        });
    
    
    
    
        props.mainView.showDialog("Potwierdź", "Czy na pewno chcesz dodać przelew zwrotny i rozliczyć dokument \"" + title + "\" ?", "yesno", (option)=>{
                      
            ///--------
            if(option == "yes")
            {
                        props.mainView.setProgress(-2);
    
                        var req = {
                            ids: ids,                            
                        }
    
                        fetch( Config.url + '/rest_v1_calc,calc_back_x', {
                            method: 'POST', 
                            body: JSON.stringify(req), 
                            headers: {
                                'Content-Type': 'application/json',                    
                                'X-Api-Key': props.userData.apiKey,
                                '_p_przedszkole_id_': props.userData.p_przedszkole_id,
                                '_p_dziecko_id_': props.userData.p_dziecko_id,
                                '_sec_key_': Config.genXKey() ,
                            }
                        })
                        .then(res => res.json() )
                        .then(res => { 
    
                                    props.mainView.setProgress(-1);        
                                    if(res._sys_ == undefined)
                                    {
                                        props.mainView.showDialog( "Error", "No correct response from server" , "ok" , null);  
                                    }else
                                    if(res.status != undefined && res.status == 'ERROR'  && res.result != undefined )
                                    {
                                        props.mainView.showDialog( "Error", JSON.stringify(res.result) , "ok" , null);  
                                    }else    
                                    {      
                                        if(res.result > 0 )                               
                                        {
                                            getTab();                                               
                                        }else 
                                        {
                                            props.mainView.showDialog( "Ups!", "Nie można dokonać zwrotu" , "ok" , null);  
                                        }
                                               
                                    }
                        } )
                        .catch(err => {          
                                    props.mainView.showDialog( "Error", "I: " + err , "ok" , null);
                                    props.mainView.setProgress(-1);
                        });
            }//koniec yes
            //--------
        } );
    
    }
    



    const goEditMass = () => {

        var ids = new Array();
                
        for(var k=0; k<selectedRow.length; k++)
            {
               if( selectedRow[k].selected == 1)
               {
                    var isOk = false;

                    //sprawdz czy jest niezatwierdzona...
                    
                    for(var y=0; y<tab.length; y++)
                    {
                        if(  tab[y].id == selectedRow[k].id &&  (tab[y].stan_dokumentu == '11'  || tab[y].stan_dokumentu == '10' )  ) 
                        isOk = true;
                    }


                    if(isOk)
                    {
                        ids.push({
                            id: selectedRow[k].id,
                            title: selectedRow[k].title
                        });
                    }

                  
               }
            }
        
            console.log("Wybrane", ids);
    
         if(ids.length < 1)     
         {       
            props.mainView.showDialog(props.userData.dic.dlg_notice_wrong , 'Nie wybrano żadnego dokumentu' ,  "ok"  ,null); 
            return;              
         }

        


         setView({
            v: 'edit_mass',
            id: -1,
         });
    }   



    const goKorMass = () => {

        var ids = new Array();
                
        for(var k=0; k<selectedRow.length; k++)
            {
               if( selectedRow[k].selected == 1)
               {
                    ids.push({
                        id: selectedRow[k].id,
                        title: selectedRow[k].title
                    });
               }
            }
        
    
         if(ids.length < 1)     
         {       
            props.mainView.showDialog(props.userData.dic.dlg_notice_wrong , 'Nie wybrano żadnego dokumentu' ,  "ok"  ,null); 
            return;              
         }

         setView({
            v: 'kor_mass',
            id: -1,
         });
    }   




    const goZip = () => {

        var ids = new Array();
                
        for(var k=0; k<selectedRow.length; k++)
            {
               if(   selectedRow[k].selected == 1)
               {
                  console.log("Logx",  selectedRow[k]);
                  if(selectedRow[k].stan_dokumentu == 10 &&  selectedRow[k].plg_pliki_id != undefined && selectedRow[k].plg_pliki_id > 0 )
                  {                    
                        ids.push({
                            //id: selectedRow[k].id,
                            id: selectedRow[k].plg_pliki_id,
                            title: selectedRow[k].title
                        });
                  }                   
               }
            }
        
    
         if(ids.length < 1)     
         {       
            props.mainView.showDialog(props.userData.dic.dlg_notice_wrong , 'Nie wybrano żadnego wystawionego dokumentu' ,  "ok"  ,null); 
            return;              
         }

         setView({
            v: 'zip',
            id: -1,
            param: ids, //id plików..
         });
    }   


    const msgNoSend = (e) => {

           props.mainView.showDialog(props.userData.dic.dlg_notice , 'Dokument nie został wysłany i nie jest widoczny dla rodzica. Wyślij go za pomoca e-mail lub sms' ,  "ok"  ,null); 
    }



    const searchParent = (e) => {

        var search = e.target.getAttribute("search");
        //alert(search);

        setFilterParam( {...filterParam, ["r_imie_nazwisko"]:search,  ["r_imie_nazwisko_valid"]:true } );
        setTab(null);
    }

    const searchKid = (e) => {

        var search = e.target.getAttribute("search");
        //alert(search);

        setFilterParam( {...filterParam, ["d_imie_nazwisko"]:search,  ["d_imie_nazwisko_valid"]:true } );
        setTab(null);
    }


    const reviewKid = (e) =>
        {
            var id        = e.target.getAttribute("id");
            var imie      = e.target.getAttribute("imie");
            var nazwisko  = e.target.getAttribute("nazwisko");
    
            props.mainView.openKid( id, imie, nazwisko );
        }



    const onSuccess = () => {
        getTab();
    }

    const goBack = () => {

        setView({
            v: "list", id: -1
        })

        getTab();
    }


    if(tab == null)
    {
        setTab([]);
        getTab();
    

        return <div>
            ...
        </div>
    }


    if(refreshView != props.userData.refreshView)
    {         
        setRefreshView( props.userData.refreshView);
        setTab(null);
        setView( {
            v:'list',
            id: -1
        });
    }



    const itemsStany = [
        { v: '_x_', title: '- - -' },
        { v: '10', title: 'Wystawiony' },
        { v: '11', title: 'Do wystawienia' },
        { v: '12', title: 'Anulowany' },
    ];


    const itemsRozliczone = [
        { v: '_x_', title: '- - -' },
        { v: 'a', title: 'Pełne rozliczenie' },        
        { v: '1', title: 'Niedopłata' },        
        { v: '3', title: 'Brak rozliczenia' },        
        { v: '4', title: 'Niedopłata lub brak rozliczenia' },        
    ];

    const itemsKorekta = [
        { v: '_x_', title: '- - -' },
        { v: '0', title: 'Ukryj wszystkie korekty' },        
        { v: '1', title: 'Pokaż tylko korekty' },         
    ];    

    const itemsTakNie = [
        { v: '_x_', title: '- - -' },
        { v: '0', title: 'Nie' },        
        { v: '1', title: 'Tak' },         
    ]; 

    const itemsWgUmowy = [
        { v: '_x_', title: '- - -' },
        { v: '1', title: 'Ręcznie' },        
        { v: '2', title: 'Na podstawie umowy' },         
    ];


    const itemsTyp = [
        { v: '_x_', title: '- - -' },
        { v: 'fr', title: 'Faktury / Rozliczenia' },        
        { v: 'kor', title: 'Korekty' },         
    ]; 


 

    var sumCzesne = 0.00;
    var sumWyzywieie = 0.00;
    var sumInne = 0.00;
    var sumDoZaplaty = 0.00;
    var sumKwotaRozliczenia = 0.00;
    var sumOdsetki = 0.00;

    var sumPozostalo = 0.00;
    var sumPozostaloOds = 0.00;



    var zaznaczonych = 0;
    var arrSelected = new Array();    
    var arrSelectedToApprove = new Array();    
    for(var s=0; s<selectedRow.length; s++)
    {
        if(selectedRow[s].selected == 1) 
        {
            zaznaczonych ++;
            arrSelected.push( selectedRow[s] );

            if(selectedRow[s].stan_dokumentu == 11)
            {
              arrSelectedToApprove.push( selectedRow[s] );
            }
           
        }
    }



    var tmpView = null;
 


    if(view.v == 'new')
    {
        return <InvoiceNew    userData={props.userData}  mainView={props.mainView}  goBack={goBack} onSuccess={onSuccess}  />
    }


    if(view.v == 'edit')
        {          
            return <InvoiceEdit    userData={props.userData}  mainView={props.mainView} id={view.id} goBack={goBack} onSuccess={onSuccess}  />
        }



   if(view.v == 'roz' && view.id > 0)
    {          
               
                return <CalculateEdit    userData={props.userData}  mainView={props.mainView}   p_saldo_ma_wn_id={view.id} goBack={goBack} onSuccess={onSuccess}  />
    }        

    if(view.v == 'zip')
    {
        tmpView = <PackToZip userData={props.userData} mainView={props.mainView} tab={view.param}   onClose={goBack} onSuccess={onSuccess}   />
    }


    if(view.v == 'edit_mass')
       {          
            var ids = new Array();
            var poz = new Array();
                    
            for(var k=0; k<selectedRow.length; k++)
                {                  
                        if( selectedRow[k].selected == 1)
                        {
                            var isOk = false;

                            //sprawdz czy jest niezatwierdzona...
                            
                            for(var y=0; y<tab.length; y++)
                            {
                                //if(  tab[y].id == selectedRow[k].id &&  tab[y].stan_dokumentu == '11') 
                                if(  tab[y].id == selectedRow[k].id &&  (tab[y].stan_dokumentu == '11' ||  tab[y].stan_dokumentu == '10')   ) 
                                isOk = true;
                            }

                            if(isOk)
                            {
                                ids.push({
                                    id: selectedRow[k].id,
                                    title: selectedRow[k].title
                                });
                            }
                               
                        }
                }


                return <InvoiceEditMass  userData={props.userData}  mainView={props.mainView} ids={ids} goBack={goBack} onSuccess={onSuccess}  />
       }        


       if(view.v == 'kor_mass')
        {          
             var ids = new Array();
             var poz = new Array();
                     
             for(var k=0; k<selectedRow.length; k++)
                 {
                         if( selectedRow[k].selected == 1)
                         {
                                 ids.push({
                                     id: selectedRow[k].id,
                                     title: selectedRow[k].title
                                 });
                         }
                 }
 
 
                 return <InvoiceKorMass  userData={props.userData}  mainView={props.mainView} ids={ids} goBack={goBack} onSuccess={onSuccess}  />
        }



    if(view.v == 'korekta')
        {
            return <InvoiceKor    userData={props.userData}  mainView={props.mainView} id={view.id} goBack={goBack} onSuccess={onSuccess}  />
        }    




        var sortList = [
            {column: "data_wystawienia", name: "Data wystawienia"  },                    
            {column: "kwota_wyzywienie", name: "Kwota - wyżywienie"  },                    
            {column: "kwota_czesne", name: "Kwota - czesne"  },                    
            {column: "kwota_inne", name: "Kwota - inne"  },                    
            {column: "do_zaplaty", name: "Do zapłaty"  },                    
            {column: "kwota_rozliczenia", name: "Kwota rozliczenia"  },                    
            {column: "pozostalo", name: "Pozostało do roz."  },                    
            {column: "dziecko_nazwisko", name: "Dziecko"  },
            {column: "rodzic_nazwisko", name: "Rodzic"  },
            {column: "numer", name: "Numer dokumentu"  },
    ]

 


      var titleRaport = "Rozliczenia i faktury "; 

    if(filterParam.p_grupa_id != '_x_') 
    {
        for(var p=0; p < gr.length; p++)
        {
            if(gr[p].v == filterParam.p_grupa_id)
            {
                titleRaport += ", " + gr[p].title;
                break;
            }
        }
    }else  titleRaport += ", wszystkie grupy" ;

    if(filterParam.data_wystawienia_od.length > 1) titleRaport += ", od dnia: " + filterParam.data_wystawienia_od ;
    if(filterParam.data_wystawienia_do.length > 1) titleRaport += ", do dnia: " + filterParam.data_wystawienia_do ;
    if(filterParam.d_imie_nazwisko.length > 1) titleRaport += ", dziecko: " + filterParam.d_imie_nazwisko ;
    if(filterParam.r_imie_nazwisko.length > 1) titleRaport += ", rodzic: " + filterParam.r_imie_nazwisko ;

  
    document.title = titleRaport;

 


    return <div className="view_content">
           

             {
                    filterParam.show == false  &&
                    <div className="  goright link_color" onClick={filterView}>
                        pokaż filtry
                   </div>
             } 



            {
                    filterParam.show == true  &&
                    <div className="table_filter">
                  

                    <div className="filter_controll">   
                        <label>Grupa: </label>                             
                        <InputComboGrupa   userData={props.userData}  mainView={props.mainView}  value={filterParam.p_grupa_id} fetchTab={fetchGr}  valChange={valChangeListener} goNext={goNextNew} name="p_grupa_id" placeholder={"Archiwalne: "}   />
                    </div> 


                    <div className="filter_controll">   
                                <label>Numer dokumentu: </label>                             
                                <InputText   userData={props.userData} value={filterParam.numer}   valChange={valChangeListener} goNext={goNextNew} name="numer" placeholder={"Numer: "}   />
                    </div>  



                    <div className="filter_controll">   
                                <label>Dziecko: </label>                             
                                <InputTextAlpha   userData={props.userData} value={filterParam.d_imie_nazwisko}   valChange={valChangeListener} goNext={goNextNew} name="d_imie_nazwisko" placeholder={"Dziecko: "}   />
                    </div>  
 

                    <div className="filter_controll">   
                                <label>Rodzic: </label>                             
                                <InputTextAlpha   userData={props.userData} value={filterParam.r_imie_nazwisko}   valChange={valChangeListener} goNext={goNextNew} name="r_imie_nazwisko" placeholder={"Rodzic: "}   />
                    </div>  

                  
 

                    <div className="filter_controll filter_merge">   
                                <label>Data wystawienia (od dnia / do dnia): </label>      <br/>                       
                                <InputDate   userData={props.userData} value={filterParam.data_wystawienia_od}   valChange={valChangeListener} goNext={goNextNew} name="data_wystawienia_od" placeholder={"Od dnia: "}   />                                                                  
                                <InputDate   userData={props.userData} value={filterParam.data_wystawienia_do}   valChange={valChangeListener} goNext={goNextNew} name="data_wystawienia_do" placeholder={"Do dnia: "}   />
                    </div> 

                    <div className="filter_controll">   
                        <label>Stan dokumentu: </label>                             
                        <InputCombo  items={itemsStany}  userData={props.userData}  mainView={props.mainView}  value={filterParam.stan_dokumentu}   valChange={valChangeListener} goNext={goNextNew} name="stan_dokumentu" placeholder={" "}   />
                    </div> 



                    <div className="filter_controll">   
                        <label>Staus rozliczenia: </label>                             
                        <InputCombo  items={itemsRozliczone}  userData={props.userData}  mainView={props.mainView}  value={filterParam.rozliczone}   valChange={valChangeListener} goNext={goNextNew} name="rozliczone" placeholder={" "}   />
                    </div> 


                    <div className="filter_controll">   
                        <label>Subkonto: </label>                             
                        <InputComboSubkonto   userData={props.userData}  mainView={props.mainView}  value={filterParam.p_subkonta_id}   valChange={valChangeListener} goNext={goNextNew} name="p_subkonta_id" placeholder={" "}   />
                    </div> 
                  

                    { 
                    (allFilter == 1) &&    
                    <span className="more_filter">

                        <div className="filter_controll">   
                            <label>Korekty: </label>                             
                            <InputCombo  items={itemsKorekta}  userData={props.userData}  mainView={props.mainView}  value={filterParam.korekta}   valChange={valChangeListener} goNext={goNextNew} name="korekta" placeholder={" "}   />
                        </div> 

                        <div className="filter_controll">   
                            <label>Dokument usunięty: </label>                             
                            <InputCombo  items={itemsTakNie}  userData={props.userData}  mainView={props.mainView}  value={filterParam.usuniety}   valChange={valChangeListener} goNext={goNextNew} name="usuniety" placeholder={" "}   />
                        </div> 

                        <div className="filter_controll filter_merge">   
                            <label>Do zapłaty (od / do): </label>        
                            <br/>                     
                            <InputDecimal   userData={props.userData}  mainView={props.mainView}  value={filterParam.do_zaplaty_od}   valChange={valChangeListener} goNext={goNextNew} name="do_zaplaty_od" placeholder={" "}   />
                            <InputDecimal   userData={props.userData}  mainView={props.mainView}  value={filterParam.do_zaplaty_do}   valChange={valChangeListener} goNext={goNextNew} name="do_zaplaty_do" placeholder={" "}   />
                        </div> 

                        <div className="filter_controll filter_merge">   
                            <label>Kwota rozliczenia (od / do): </label>        
                            <br/>                     
                            <InputDecimal   userData={props.userData}  mainView={props.mainView}  value={filterParam.kwota_rozliczenia_od}   valChange={valChangeListener} goNext={goNextNew} name="kwota_rozliczenia_od" placeholder={" "}   />
                            <InputDecimal   userData={props.userData}  mainView={props.mainView}  value={filterParam.kwota_rozliczenia_do}   valChange={valChangeListener} goNext={goNextNew} name="kwota_rozliczenia_do" placeholder={" "}   />
                        </div>

                        
                        <div className="filter_controll filter_merge">   
                            <label>Pozostało do roz. (od / do): </label>        
                            <br/>                     
                            <InputDecimal   userData={props.userData}  mainView={props.mainView}  value={filterParam.pozostalo_od}   valChange={valChangeListener} goNext={goNextNew} name="pozostalo_od" placeholder={" "}   />
                            <InputDecimal   userData={props.userData}  mainView={props.mainView}  value={filterParam.pozostalo_do}   valChange={valChangeListener} goNext={goNextNew} name="pozostalo_do" placeholder={" "}   />
                        </div>


                        <div className="filter_controll">   
                          <label>Wysłano e-mail: </label>                             
                          <InputCombo  items={itemsTakNie}  userData={props.userData}  mainView={props.mainView}  value={filterParam.wyslano_e_fakture}   valChange={valChangeListener} goNext={goNextNew} name="wyslano_e_fakture" placeholder={" "}   />
                       </div> 

                       <div className="filter_controll">   
                          <label>Wysłano SMS: </label>                             
                          <InputCombo  items={itemsTakNie}  userData={props.userData}  mainView={props.mainView}  value={filterParam.wyslano_sms}   valChange={valChangeListener} goNext={goNextNew} name="wyslano_sms" placeholder={" "}   />
                       </div> 

                       <div className="filter_controll">   
                          <label>Sposób wystawienia: </label>                             
                          <InputCombo  items={itemsWgUmowy}  userData={props.userData}  mainView={props.mainView}  value={filterParam.wg_umowy}   valChange={valChangeListener} goNext={goNextNew} name="wg_umowy" placeholder={" "}   />
                       </div> 


                                              
                        <div className="filter_controll">   
                            <label>ZAWIERA wszystkie wybrane stawki: </label>                             
                            <InputComboStawkiWyzMulti  value={filterParam.zawiera_stawke}    userData={props.userData}  mainView={props.mainView}    valChange={valChangeListener} goNext={goNextNew} name="zawiera_stawke"    />
                        </div> 


                        <div className="filter_controll">   
                            <label>NIE zawiera żadnej z wybranej stawki: </label>                             
                            <InputComboStawkiWyzMulti  value={filterParam.niezawiera_stawki}    userData={props.userData}  mainView={props.mainView}    valChange={valChangeListener} goNext={goNextNew} name="niezawiera_stawki"    />
                        </div> 

                        

                    </span>
                    }


                    <div className="filter_btn">
                                {
                                    allFilter == 1 &&
                                    <span className="link_color" onClick={moreFilter} >mniej filtrów</span>
                                }

                                {
                                    allFilter == 0 &&
                                    <span className="link_color" onClick={moreFilter} >więcej filtrów</span>
                                }
                                
                                &nbsp;&nbsp;
                                <span className="link_color" onClick={filterView}>&nbsp;ukryj filtry&nbsp;</span> 
                                <span className="btn" onClick={filterApprove} >filtruj</span>&nbsp;&nbsp;<span className="btn" onClick={filterClear} >wyczyść</span>
                    </div>



            </div>
            } 


          

            
            <div className="bg_center">
                            
                            <div className="table_widget">
                               
                              
                                     <InvoiceGenerate userData={props.userData} mainView={props.mainView} onSuccess={onSuccess}  />
                                     &nbsp; 
                                     <div className="btn" onClick={changeView} v="new" id="-1"  > Nowy dokument</div>

                                    <InputPagger filter={filterParam}  onChange={onChangePagger}  />
                                        
                                    <InputLegend items={legend}    valChange={valChangeListener} />

                                    &nbsp; &nbsp;
                                    <HtmlToPDF tabRef={tabRef} userData={props.userData} mainView={props.mainView}  orientation="landscape" title={titleRaport} />   
                                    <Csv tabRef={tab2Ref}  title={titleRaport} />                  
                                    <Xlsx tabRef={tab2Ref}  title={titleRaport} />                  
                                    <Print tabRef={tab2Ref}   title={titleRaport} />

                                    <SortBy  cols={sortList} param={filterParam.sortBy}  onChange={onChangeSortBy}  />
                                   
                            </div>


                            <div className="table_mass">  
                                    <div className="title_mass">Operacje masowe (zaznaczono: {zaznaczonych}) </div>
                                    &nbsp;

                                     
                                    <InvoiceApprove userData={props.userData} mainView={props.mainView} selected={arrSelectedToApprove} onSuccess={onSuccess}  />

                                    &nbsp;
                                    <span className="btn" onClick={goCancel}  >Anuluj / Usuń (nierozliczone)</span>
                                    &nbsp;
                                    <span className="btn" onClick={goRestore}  >Przywróć</span>
                                    &nbsp;
                                    <span className="btn"   onClick={goPrint}  >Drukuj</span>
                                    &nbsp;
                                    <span className="btn"   onClick={goZip}  > Archiwum .ZIP</span>
                                    &nbsp;
                                    <span className="btn"  onClick={goSendByEmail} >** Wyślij jako e-fakturę</span>
                                    &nbsp;
                                    <span className="btn"   onClick={goSendBySMS}   >** Wyślij SMSem</span>
                                    &nbsp;
                                    <span className="btn"  onClick={goEditMass}  >Edycja masowa</span>
                                    &nbsp;
                                    <span className="btn"  onClick={goKorMass}  >Wystaw korekty</span>
                                    <br/>
                                    <br/>
                                    <div>
                                        ** Rachunek jest widoczny w aplikacji dla rodziców dopiero po jego wysłaniu (elektronicznie lub smsem)
                                    </div>
                            </div>




                            <div ref={tabRef} className="gohide">
                                    <h3>{titleRaport}</h3>   
                                    <table className="table" ref={tab2Ref}>
                                        <thead>
                                            <tr className="header">                                                                                  
                                                <td>LP</td>                                                                                                                                
                                                <td>Numer</td>                                                                                                                                
                                                <td>Data</td>                                                                                                                                
                                                <td>Rodzic</td>                                                                                                                                
                                                <td>Dziecko</td>                                                                                                                                
                                                <td>Termin płatności</td>                                                                                                                                
                                                <td>Czesne</td>                                                                                                                                
                                                <td>Wyżywienie</td>                                                                                                                                
                                                <td>Inne</td>                                                                                                                                
                                                <td>Do zapłaty</td>                                                                                                                                
                                                <td>Kwota rozliczenia</td>                                                                                            
                                                <td>Naliczone odsetki</td>                                                                                                                             
                                                <td>Pozostało ods.</td>                                                                                                                             
                                            </tr>
                                        </thead>
                                        <tbody>
                                                {

                                                    

                                                    tab.map( (row, inx) => {


                                                        sumCzesne           = parseFloat( sumCzesne ) + parseFloat(row.kwota_czesne);
                                                        sumWyzywieie        = parseFloat( sumWyzywieie ) + parseFloat(row.kwota_wyzywienie);
                                                        sumInne             = parseFloat( sumInne ) + parseFloat(row.kwota_inne);
                                                        sumDoZaplaty        = parseFloat( sumDoZaplaty ) + parseFloat(row.do_zaplaty);
                                                        sumKwotaRozliczenia   = parseFloat( sumKwotaRozliczenia ) + parseFloat(row.kwota_rozliczenia);
                                                        sumOdsetki          = parseFloat( sumOdsetki ) + parseFloat(row.kwota_odsetek);

                                                        sumPozostalo          = parseFloat( sumPozostalo ) + parseFloat(row.pozostalo);
                                                        sumPozostaloOds          = parseFloat( sumPozostaloOds ) + parseFloat(row.ods_pozostalo);

                                                        return <tr className="row">                                                                                                         
                                                                <td className="gocenter">{inx+1}</td>                                                                                                                                
                                                                <td className="gocenter">{row.numer}</td>                                                                                                                                
                                                                <td className="gocenter">{row.data_wystawienia}</td>                                                                                                                                
                                                                <td>{row.rodzic.nazwisko + " " + row.rodzic.imie}</td>                                                                                                                                
                                                                <td>{row.dziecko.nazwisko + " " + row.dziecko.imie}</td>                                                                                                                                
                                                                <td className="gocenter">{row.termin_platnosci}</td>                                                                                                                                
                                                                <td className="goright"><FormatDecimal value={row.kwota_czesne}/></td>                                                                                                                                
                                                                <td className="goright"><FormatDecimal value={row.kwota_wyzywienie}/></td>                                                                                                                                
                                                                <td className="goright"><FormatDecimal value={row.kwota_inne}/></td>                                                                                                                                
                                                                <td className="goright"><FormatDecimal value={row.do_zaplaty}/></td>                                                                                                                                
                                                                <td className="goright"><FormatDecimal value={row.kwota_rozliczenia}/></td>                                                                                            
                                                                <td className="goright"><FormatDecimal value={row.kwota_odsetek}/></td>                                                                                                                                                              
                                                                <td className="goright"><FormatDecimal value={row.ods_pozostalo}/></td>                                                                                                                                                              
                                                       
                                                        </tr>
                                                    } )
                                                }

                                                        <tr className="row sums">
                                                                                                         
                                                                <td className="gocenter"> </td>                                                                                                                                
                                                                <td className="gocenter"> </td>                                                                                                                                
                                                                <td className="gocenter"> </td>                                                                                                                                
                                                                <td> </td>                                                                                                                                
                                                                <td> </td>                                                                                                                                
                                                                <td className="gocenter"> </td>                                                                                                                                
                                                                <td className="goright"><FormatDecimal value={sumCzesne}/></td>                                                                                                                                
                                                                <td className="goright"><FormatDecimal value={sumWyzywieie}/></td>                                                                                                                                
                                                                <td className="goright"><FormatDecimal value={sumInne}/></td>                                                                                                                                
                                                                <td className="goright"><FormatDecimal value={sumDoZaplaty}/></td>                                                                                                                                
                                                                <td className="goright"><FormatDecimal value={sumPozostalo}/></td>                                                                                            
                                                                <td className="goright"><FormatDecimal value={sumOdsetki}/></td>                                                                                                                                                                                                                               
                                                                <td className="goright"><FormatDecimal value={sumPozostaloOds}/></td>                                                                                                                                                                                                                               
                                                        </tr>

                                        </tbody>
                            </table>
                            </div>

                    <div className="scorll_x">
                            <table className="table" >
                                        <thead>
                                            <tr className="header">
                                                <td className="link_normal td_left" onClick={changeSelectedAll}>Z</td>                                                  
                                                <td>LP</td>                                                                                                                                
                                                <td>V</td>                                                                                                                                
                                                <td>Numer</td>                                                                                                                                
                                                <td>Data</td>                                                                                                                                
                                                <td>Dziecko</td>   
                                                <td>Rodzic</td>                                                                                                                                                                                                                                                                                                            
                                                <td>Płatne do</td>                                                                                                                                                                                                                                                                                                              
                                                <td>Czesne</td>                                                                                                                                
                                                <td>Wyż.</td>                                                                                                                                
                                                <td>Inne</td>                                                                                                                                
                                                <td>Do zapłaty</td>                                                                                                                                
                                                <td>Pozostało</td>                                                                                            
                                                <td>Naliczone odsetki</td>  
                                                <td>Pozostało (ods)</td>  
                                                <td className="td_right">Wysłano</td> 
                                                <td className="td_option"></td>                                                                                                                           
                                                                                                                                                              
                                            </tr>
                                        </thead>
                                        <tbody>
                                                {

                                                    

                                                    tab.map( (row, inx) => {


                                                  

                                                        var css = " ";
                                                        if(row.stan_dokumentu == '11') css = 'color_show3';
                                                        if(row.do_zaplaty == row.kwota_rozliczenia == '1') css = 'color_show2';
                                                        if(row.stan_dokumentu == '12') css = 'color_deleted';
                                                        if(row.is_delete == '1') css = 'color_deleted2';                                           

                                                        if(row.po_terminie == '1') css = 'color_wrong';                                           


                                                        var isChecked = "";

                                                        for(var s=0; s<selectedRow.length; s++)
                                                            {
                                                                if( selectedRow[s].id == row.id &&  selectedRow[s].selected == 1) isChecked = "checked";
                                                            }


                                                        var editView = "edit";
                                                        if(row.korekta_f_faktura_id > 0) editView = "korekta";


                                                        var wysylka = <span className="link_bad" title="Nie wysłano - rodzic nie widzi dokumentu w aplikacji" onClick={msgNoSend}>nie wysłano!</span>;

                                                        if(row.wyslano_sms == "1" && row.wyslano_e_fakture == "1")
                                                        {
                                                            wysylka = "e-mail i sms";
                                                        }

                                                        if(row.wyslano_sms == "1" && row.wyslano_e_fakture != "1")
                                                            {
                                                                wysylka = "sms";
                                                            }

                                                        if(row.wyslano_sms != "1" && row.wyslano_e_fakture == "1")
                                                            {
                                                                    wysylka = "e-mail";
                                                            }    


                                                        var rowStyle = " row ";
                                                            if(inx % 2 == 0 )rowStyle = " row2 ";    

                                                        return <tr className={rowStyle + css}>
                                                                <td className="gocenter">
                                                                    <input type="checkbox" atr-id={row.id} onChange={changeSelected} checked={isChecked} />
                                                                </td>                                             
                                                                <td className="gocenter">{inx+1}</td>   


                                                                <td className="gocenter txtcloud" >      
                                                                     <span className="txt_square" onClick={changeView} v={editView} id={row.id}></span>
                                                                     <span className="info_content">
                                                                              <span className="info_cloud shadowx"  >         
                                                                                <span className="info_title">{row.numer} (za: {row.okres_od} / {row.okres_do})</span>                                                                                         
                                                                                 <ul>
                                                                                     {
                                                                                        row.pozycje.map( (poz, inx) => {
                                                                                            return <li>
                                                                                                {poz.nazwa + ",cena: " + poz.cena_j_netto + ", ilość: " + poz.ilosc +", razem:  " + poz.kwota_brutto}
                                                                                            </li>
                                                                                        } )
                                                                                     }
                                                                                 </ul>
                                                                              </span>
                                                                     </span> 
                                                                 </td>



                                                                <td className="goleft link_normal" onClick={changeView} v={editView} id={row.id}  >
                                                                    {row.numer}
                                                                    {
                                                                        row.p_umowa_id > 0 &&
                                                                        <sup title="Wystawione na podstawie umowy">
                                                                            <img src={contract} className="small_tip_img" title="Wystawione na podstawie umowy"  onClick={changeView} v={editView} id={row.id}  />
                                                                        </sup>
                                                                    }
                                                                </td>       
                                                                <td className="gocenter">{row.data_wystawienia}</td>                                                                                                                                
                                                                <td>
                                                                    {row.dziecko.nazwisko + " " + row.dziecko.imie}
                                                                    <img src={gopresent} id={row.dziecko.id} imie={row.dziecko.imie} nazwisko={row.dziecko.nazwisko} onClick={reviewKid} title="podgląd"  />    
                                                                    <img src={search} className="small_tip_img" title="Pokaż tylko to dziecko"  search={row.dziecko.nazwisko + " " + row.dziecko.imie} onClick={searchKid} />

                                                                </td>    
                                                                <td>
                                                                     {row.rodzic.nazwisko + " " + row.rodzic.imie}  
                                                                     <img src={search} className="small_tip_img" title="Pokaż tylko tego rodzica"  search={row.rodzic.nazwisko + " " + row.rodzic.imie} onClick={searchParent} />
                                                                     <QuickChat id={row.rodzic.id}  title={row.rodzic.imie +" " + row.rodzic.nazwisko } mainView={props.mainView} userData={props.userData} /> 
                                                                </td>       
                                                                <td className="gocenter">{row.termin_platnosci}</td>                                                                                                                                                                                                                                                                                                                               
                                                                <td className="goright link_normal" title="Idź do rozliczeń"  onClick={changeView} v="roz" id={row.p_saldo_ma_wn_id}  ><FormatDecimal value={row.kwota_czesne}/></td>                                                                                                                                
                                                                <td className="goright link_normal" title="Idź do rozliczeń"  onClick={changeView} v="roz" id={row.p_saldo_ma_wn_id}  ><FormatDecimal value={row.kwota_wyzywienie}/></td>                                                                                                                                
                                                                <td className="goright link_normal" title="Idź do rozliczeń"  onClick={changeView} v="roz" id={row.p_saldo_ma_wn_id}  ><FormatDecimal value={row.kwota_inne}/></td>                                                                                                                                
                                                                <td className="goright link_normal" title="Idź do rozliczeń"  onClick={changeView} v="roz" id={row.p_saldo_ma_wn_id} ><FormatDecimal value={row.do_zaplaty}/></td>                                                                                                                                
                                                                <td className="goright link_normal" title="Idź do rozliczeń"   onClick={changeView} v="roz" id={row.p_saldo_ma_wn_id} ><FormatDecimal value={row.pozostalo}/></td>                                                                                            
                                                                <td className="goright link_normal" title="Idź do rozliczeń"   onClick={changeView} v="roz" id={row.p_saldo_ma_wn_id}  ><FormatDecimal value={row.kwota_odsetek}/></td>                                                                                                                                                              
                                                                <td className="goright link_normal" title="Idź do rozliczeń"  onClick={changeView} v="roz" id={row.p_saldo_ma_wn_id} ><FormatDecimal value={row.ods_pozostalo}/></td>   
                                                                <td className="gocenter">{wysylka}</td>   

                                                                <MenuTable>

                                                                    <ul>

                                                                         

                                                                            {                                                                   
                                                                                (row.stan_dokumentu == '10' && (row.kwota_rozliczenia == 0 && row.kwota_rozliczenia_odsetek == 0) ) &&                                                                                  
                                                                                <Fragment>
                                                                                    <li  atr-id={row.id} atr-title={row.numer}  onClick={cancelInvoice} >anuluj</li>
                                                                                </Fragment>
                                                                            }

                                                                            {
                                                                                  row.stan_dokumentu == '12' &&  
                                                                                  <Fragment>
                                                                                    <li  atr-id={row.id} atr-title={row.numer}  onClick={restoreInvoice} >przywróć</li>
                                                                                  </Fragment>
                                                                            }

                                                                            {
                                                                                 row.stan_dokumentu == '11' && 
                                                                                 <Fragment>
                                                                                      <li  atr-id={row.id} atr-title={row.numer}  onClick={cancelInvoice} >usuń</li>
                                                                                 </Fragment>
                                                                            }

                                                                            <li onClick={changeView} v={editView} id={row.id}>
                                                                                edytuj dane 
                                                                            </li>

                                                                            {
                                                                                row.stan_dokumentu == '10'  &&       
                                                                                <Fragment>  
                                                                                    <li  atr-id={row.id} atr-title={row.numer}   onClick={goKorekta}  >wystaw korektę</li>
                                                                                </Fragment>
                                                                            }

                                                                            {
                                                                                row.stan_dokumentu == '10'  &&   row.do_zaplaty < 0 &&    row.kwota_rozliczenia == 0 && 
                                                                                <Fragment>  
                                                                                    <li  atr-id={row.id} atr-title={row.numer}   onClick={goZwrot}  >dodaj i rozlicz zwrot</li>
                                                                                </Fragment>
                                                                            }

                                                                            {                                                                   
                                                                                row.stan_dokumentu == '10'   &&                                                                                  
                                                                                <Fragment>
                                                                                    <li  atr-id={row.id} atr-title={row.numer}  onClick={goPrintOne} >drukuj</li>
                                                                                </Fragment>
                                                                            }
                                                                    </ul>

                                                                </MenuTable>

                                      

                                                       
                                                        </tr>
                                                    } )
                                                }

                                                        <tr className="row sums">
                                                                <td className="link_normal" > </td>                                                
                                                                <td className="gocenter"> </td>                                                                                                                                
                                                                <td className="gocenter"> </td>                                                                                                                                
                                                                <td className="gocenter"> </td>                                                                                                                                
                                                                <td> </td>                                                                                                                                
                                                                <td> </td>                                                                                                                                
                                                                <td> </td>                                                                                                                                                                                                                                                                                                                            
                                                                <td className="gocenter"> </td>                                                                                                                                
                                                                <td className="goright"><FormatDecimal value={sumCzesne}/></td>                                                                                                                                
                                                                <td className="goright"><FormatDecimal value={sumWyzywieie}/></td>                                                                                                                                
                                                                <td className="goright"><FormatDecimal value={sumInne}/></td>                                                                                                                                
                                                                <td className="goright"><FormatDecimal value={sumDoZaplaty}/></td>                                                                                                                                
                                                                <td className="goright"><FormatDecimal value={sumPozostalo}/></td>                                                                                            
                                                                <td className="goright"><FormatDecimal value={sumOdsetki}/></td> 
                                                                <td className="goright"><FormatDecimal value={sumPozostaloOds}/></td> 
                                                                <td> </td>    
                                                                <td> </td>                                                                                                                                                                                                                              
                                                                <td> </td>                                                                                                                                                                                                                              
                                                                <td> </td>                                                                                                                                                                                                                              
                                                                                                                                                                                                                                                                                      
                                                        </tr>

                                        </tbody>
                            </table>
                    </div>




                    {
                        tabSum != null && tabSum.length > 0 &&
                        <Fragment>

                                <br/>                            
                                <div className="calColor">*Podsumowanie widocznych pozycji</div>
                                <p>
                                    Podsumowanie obejmuje tylko pozycje zesłownikowane (ustawienia - Stawki i opłaty obowiązujące w placówce), które zostały utworzone wg. umowy.
                                </p>
                                <br/>

                                <div className="table_widget">              
                                    &nbsp; &nbsp;
                                    <HtmlToPDF tabRef={sumRefPdf} userData={props.userData} mainView={props.mainView}  orientation="landscape" title={titleRaport} />   
                                    <Csv tabRef={sumRef}  title={titleRaport} />                  
                                    <Xlsx tabRef={sumRef} title={titleRaport} />                  
                                    <Print tabRef={sumRef} />    
                            </div>

                                <div className="scorll_x">

                                        <div ref={sumRefPdf}>
                                            <h3>{titleRaport}</h3>

                                                <table className="table" ref={sumRef} >
                                                            <thead>
                                                                <tr className="header">                                                                                  
                                                                    <td className="td_left">LP</td>                                                                                                                                                                                                                                                                                                                                                                                                                                                                  
                                                                    <td>Nazwa</td>                                                                                                                                                                                                                                                                                                                                                                                                                                                                  
                                                                    <td>Suma Netto</td>                                                                                                                                                                                                                                                                                                                                                                                                                                                                  
                                                                    <td>Suma Vat</td>                                                                                                                                                                                                                                                                                                                                                                                                                                                                  
                                                                    <td className="td_right">Suma Brutto</td>                                                                                                                                                                                                                                                                                                                                                                                                                                                                  
                                                                </tr>
                                                            </thead>
                                                            <tbody>
                                                                    { 
                                                                        tabSum.map( (row, inx) => {
                    
                                                                            var css = " ";
                                                                        
                                                                            var rowStyle = " row ";
                                                                                if(inx % 2 == 0 )rowStyle = " row2 ";    

                                                                            return <tr className={rowStyle + css}>                                                                                                            
                                                                                    <td className="gocenter">{inx+1}</td>                                                           
                                                                                    <td className="goleft">{row.nazwa}</td>                                                           
                                                                                    <td className="goright"><FormatDecimal value={row.kwota_netto} /></td>                                                           
                                                                                    <td className="goright"><FormatDecimal value={row.kwota_vat} /></td>                                                           
                                                                                    <td className="goright"><FormatDecimal value={row.kwota_brutto} /></td>                                                           
                                                                            </tr>
                                                                        } )
                                                                    }

                                                                    
                                                            </tbody>
                                                </table>

                                        </div>

                                      
                                </div>

                        </Fragment>
                    }

                 




                    
                            {tmpView}
            </div>



    </div>
  
  
  
     

}


export default Invoice;